import { RootState } from "typedefs";
import { useSelector } from "app/utils/hooks";

export const useCoachProfile = () => {
  const currentUser = useSelector((state: RootState) => state.user);
  const facilityCoaches = useSelector((state: RootState) => state.user?.self?.scheduling?.facility.coachProfiles) || [];

  if (currentUser.pending) {
    return { data: null, pending: true };
  }

  const currentCoach = facilityCoaches.find(c => c.id === currentUser.self.id);

  return { data: currentCoach, pending: !currentCoach };
};
